export const FETCH_ALL_PLACES = "FETCH_ALL_PLACES";
export const CREATE_PLACE = "CREATE_PLACE";
export const UPDATE_PLACE = "UPDATE_PLACE";
export const DELETE_PLACE = "DELETE_PLACE";
export const LIKE_PLACE = "LIKE_PLACE";
export const COMMENT_PLACE = "COMMENT_PLACE";
export const FETCH_PLACE = "FETCH_PLACE";
export const FETCH_PLACES_BY_SEARCH = "FETCH_PLACES_BY_SEARCH";

export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
